module.exports = __webpack_public_path__ + "media/customizations/regencyatfolsomranch/logo-new-30aa053e226b2e6c11b0b747329f982b.png";